import { SearchExpression } from '../../model/search/advanced/SearchExpression';
import { AdvancedSearch } from '../../model/search/advanced/AdvancedSearch';
import { SearchContext } from '../../model/search/ISearch';

import { Factory } from '../../services/Factory';
import { Preferences } from '../../model/user/Preferences';
import { PreferenceService } from '../../services/user/PreferenceService';


export interface IResourceFilterScope extends angular.IScope {
  displayMode: any;
  DisplayMode: any;
  resource;
  showCollections: boolean;
  noIndent: boolean;
  launchResource: Function;
}

export interface IResourceFilterAttributes extends angular.IAttributes {
}

export class ResourceFilter implements angular.IDirective {
  public restrict = "EA";
  public templateUrl: string;
  public scope = {
    project: "=",
    collections: "=",
    resources: "=",
    paginationObj: "=",
    resourcesPage: "=",
    totalResources: "=",
    totalPageCount: "=",
    totalFileSize: "=",
    columnFilters: "=",
    selectAll: "=",
    initialPageLoading: "="
  };
  public link: (scope: IResourceFilterScope, element: angular.IAugmentedJQuery, attrs: IResourceFilterAttributes) => void;
  private preferenceService: app.services.user.PreferenceService;
  private tagService: app.services.tagging.TagService;
  private $scope: IResourceFilterScope;

  constructor($uibModal, $timeout: angular.ITimeoutService, notificationService: app.services.INotificationService, tagService: app.services.tagging.TagService, preferenceService: app.services.user.PreferenceService) {
    this.templateUrl = "partials/resource_filter.html";
    this.link = (scope: IResourceFilterScope, element: angular.IAugmentedJQuery, attrs: IResourceFilterAttributes) => {
      this.$scope = scope;
      this.preferenceService = preferenceService;
      this.tagService = tagService;

      scope.tagCounts = [["Tag", "Count"]];
      scope.collectionIds = [];
      scope.loading = true;
      scope.dirtyFilter = false;
      scope.DisplayMode = DisplayMode;
      scope.displayMode = preferenceService.Get(Preferences.DISPLAY_MODE) || DisplayMode.ListView;
      scope.selectAll = false;

      scope.showFilterButton = 0;

      scope.filter = this.GetCleanFilter();

      scope.filterCopy = this.GetCleanFilter();

      scope.refresh = function () {
        scope.$emit(PreferenceService.GetEventForPreference(Preferences.DISPLAY_MODE), scope.displayMode);
      };

      // On init
      scope.$watchGroup(["collections", "project"], newValues => {
        const collections = newValues[0];
        const project = newValues[1];

        if (collections && project) {
          scope.collectionIds = _.pluck(collections, "id");
          this.RestoreFilter();
        }
      });

      scope.$watch("filter.size", newValue => {
        if (scope.loading && newValue !== "undefined") {
          scope.loading = false;
          scope.showFilterButton = +newValue > 0;
        }
      }, true);

      scope.$watch("filterCopy", newValue => newValue && (scope.dirtyFilter = !angular.equals(newValue, scope.filter)), true);

      scope.$watch("selectAll", value => {
        if (value && scope.resources) {
          scope.resources.splice(0);
        }
      });

      scope.revertFilter = () => {
        this.SetFilterCopy(scope.filter);
        scope.dirtyFilter = false;
      };

      scope.applyFilter = () => {
        this.SetFilter(scope.filterCopy);
        scope.dirtyFilter = false;
      };

      scope.clearFilter = () => {
        const cleanFilter = this.GetCleanFilter();
        this.SetFilter(cleanFilter);
        this.SetFilterCopy(cleanFilter);
        scope.dirtyFilter = false;
      };

      scope.generateResourceReport = () => {
        const currentDate = new Date();

        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/reporting/dialog_report.html",
          controller: "AddReportModalCtrl",
          scope: scope,
          resolve: {
            project: () => scope.project,
            config: () => {
              return {
                type: "resource_report",
                format: "csv",
                name: "Resource Report " +
                  (currentDate.getMonth() + 1) + "/" +
                  currentDate.getDate() + "/" +
                  currentDate.getFullYear() + " @ " +
                  currentDate.getHours() + ":" +
                  currentDate.getMinutes() + ":" +
                  currentDate.getSeconds()
              };
            },
            formConfig: () => {
              return {}
            },
            collections: () => scope.collectionIds,
            filter: () => scope.cookieFilter,
            search: null
          }
        });
      };

      scope.generateTagReport = () => {
        const currentDate = new Date();

        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_tag_report.html",
          controller: "AddTagReportModalCtrl",
          scope: scope,
          resolve: {
            project: () => scope.project,
            config: () => {
              return {
                type: "tag_report",
                name: "Tag Report " +
                  (currentDate.getMonth() + 1) + "/" +
                  currentDate.getDate() + "/" +
                  currentDate.getFullYear() + " @ " +
                  currentDate.getHours() + ":" +
                  currentDate.getMinutes() + ":" +
                  currentDate.getSeconds()
              };
            },
            formConfig: () => {
              return {}
            },
            collections: () => scope.collectionIds,
            filter: () => scope.cookieFilter,
            search: null
          }
        });
      };

      scope.createBatches = () => {
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/batching/dialog_batch.html",
          controller: "AddBatchModalController",
          scope: scope,
          resolve: {
            project: () => scope.project,
            collection: () => scope.collections,
            search: () => scope.columnFilters ? new AdvancedSearch(SearchContext.Collection, scope.columnFilters) : null,
            columnFilters: () => null,
            filter: () => scope.cookieFilter,
            resources: () => scope.selectAll ? undefined : scope.resources,
            selectAll: () => scope.selectAll
          }
        });
      };

      scope.$watch("displayMode", (value: DisplayMode, prev: DisplayMode) => {
        if (value !== prev) {
          scope.displayMode = value;
          preferenceService.Set(Preferences.DISPLAY_MODE, value);
          scope.$emit(PreferenceService.GetEventForPreference(Preferences.DISPLAY_MODE), value);
        }
      });
    }
  };

  private RestoreFilter() {
    // Load Filters after we have collections
    const storedFilter = this.preferenceService.CurrentFilter;

    if (!_.isEmpty(storedFilter) && storedFilter.size > 0 && storedFilter.projectId == this.$scope.project.id) {
      this.BuildFilterFromCookie(storedFilter.tags);
    } else {
      const cleanFilter = this.GetCleanFilter();
      this.SetFilter(cleanFilter);
      this.SetFilterCopy(cleanFilter);
    }
  }

  private BuildFilterFromCookie(tagBoolean) {
    const ids = _.union(
      tagBoolean.and,
      tagBoolean.or,
      tagBoolean.not
    );

    if (_.isEmpty(ids)) {
      return;
    }

    this.tagService.FindMany(this.$scope.project.id, ids as string[], tags => {
      const filter = this.GetCleanFilter();

      if (!_.isEmpty(tags)) {
        const tagMap = {};

        angular.forEach(tags, tag => tagMap[tag.id] = tag);

        angular.forEach(tagBoolean.and, id => {
          filter.tags.and.push(tagMap[id]);
          filter.size++;
        });

        angular.forEach(tagBoolean.or, id => {
          filter.tags.or.push(tagMap[id]);
          filter.size++;
        });

        angular.forEach(tagBoolean.not, id => {
          filter.tags.not.push(tagMap[id]);
          filter.size++;
        });
      }

      this.SetFilter(filter);
      this.SetFilterCopy(filter);
    });
  }

  private CopyBoolean(arrayTo, arrayFrom) {
    arrayTo.length = 0;
    angular.forEach(arrayFrom, item => arrayTo.push(item));
  }

  private SetFilterProperties(filterTo, filterFrom) {
    filterTo.size = filterFrom.size;
    this.CopyBoolean(filterTo.tags.and, filterFrom.tags.and);
    this.CopyBoolean(filterTo.tags.or, filterFrom.tags.or);
    this.CopyBoolean(filterTo.tags.not, filterFrom.tags.not);
  }

  private SetFilter(filter) {
    this.SetFilterProperties(this.$scope.filter, filter);
    this.BuildFilterForCookie(this.$scope.filter.tags); // save filter in cookie
    this.$scope.$emit("fetchResources");
  }

  private SetFilterCopy(filterCopy) {
    this.SetFilterProperties(this.$scope.filterCopy, filterCopy);
  }

  private GetCleanFilter() {
    return {
      projectId: this.$scope.project ? this.$scope.project.id : null,
      size: 0,
      tags: {
        "and": [],
        "or": [],
        "not": []
      }
    };
  }

  private BuildFilterForCookie(tagBoolean) {
    // Our trimmed down version of tagBoolean
    const filter = this.GetCleanFilter();

    angular.forEach(tagBoolean.and, tag => {
      filter.tags.and.push(tag.id);
      filter.size++;
    });
    angular.forEach(tagBoolean.or, tag => {
      filter.tags.or.push(tag.id);
      filter.size++;
    });
    angular.forEach(tagBoolean.not, tag => {
      filter.tags.not.push(tag.id);
      filter.size++;
    });

    this.$scope.cookieFilter = filter;
    this.$scope.paginationObj.filterString = JSON.stringify(filter);
    this.$scope.filter.size = filter.size;
    this.$scope.filterCopy.size = filter.size;
    this.preferenceService.CurrentFilter = filter;
  }
}

frontendApp.directive("iioResourceFilter", ["$uibModal", "$timeout", "NotificationService", "TagService", "PreferenceService", Factory.Create(ResourceFilter)]);
